// import {
//   Autocomplete,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   FormControl,
//   Grid,
//   InputLabel,
//   MenuItem,
//   Select,
//   TextField,
// } from "@mui/material";
// import Cookies from "js-cookie";
// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom"; // Replace Next.js router with React Router
// import { toast } from "react-toastify";
// import DynamicTable from "../../Components/Table/DynamicTable"; // Keep your custom component as is
// import { fetchCustomerData } from "../../Redux/Slice/AddCustomer";
// import {
//   assignTaskChangeMember,
//   CreateAssignTask,
//   fetchActiveMemberData,
//   fetchAllTask,
//   ShowAssignedTask,
// } from "../../Redux/Slice/TaskMasterSlice";

// const AssignTask = () => {
//   const formatDate = (isoDate) => {
//     const date = new Date(isoDate);
//     return `${date.getDate().toString().padStart(2, "0")}/${(
//       date.getMonth() + 1
//     )
//       .toString()
//       .padStart(2, "0")}/${date.getFullYear()}`;
//   };

//   const dispatch = useDispatch();
//   const loginData = Cookies.get("loginData");
//   const parsedData = loginData ? JSON.parse(loginData) : null;
//   const navigate = useNavigate();

//   const { ActiveMemberData, FindAllTask, ShowASsignedTaskData } = useSelector(
//     (state) => state.TaskMaster
//   );

//   const { CustomerData } = useSelector((state) => state.AddCustomer);

//   useEffect(() => {
//     dispatch(fetchActiveMemberData());
//     dispatch(fetchAllTask());
//     dispatch(fetchCustomerData());
//     dispatch(ShowAssignedTask(parsedData?.data?._id));
//   }, [dispatch, parsedData?.data?._id]);

//   const [formData, setFormData] = useState({
//     TaskId: "",
//     MemberId: [],
//     CompanyId: "",
//     DueDate: "",
//     Remark: "",
//     AssignedBy: parsedData.data._id,
//   });

//   const Member =
//     ActiveMemberData?.data?.map((el) => ({
//       Name_id: el._id,
//       Name_name: el.Name,
//     })) || [];

//   const [formErrors, setFormErrors] = useState({});

//   const validateForm = () => {
//     const errors = {};

//     if (!formData.CompanyId) {
//       errors.CompanyId = "Company Name is required";
//     }

//     if (formData.MemberId.length === 0) {
//       errors.MemberId = "Member is required";
//     }

//     if (!formData.DueDate) {
//       errors.DueDate = "Due Date is required";
//     }

//     if (!formData.Remark || formData.Remark.trim() === "") {
//       errors.Remark = "Remark is required";
//     }

//     if (!formData.TaskId) {
//       errors.TaskId = "Task is required";
//     }

//     return errors;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevValues) => ({
//       ...prevValues,
//       [name]: value,
//     }));
//   };

//   const handleAutocompleteChange =
//     (name, isMultiSelect = false) =>
//     (event, newValue) => {
//       let valueToStore = "";

//       if (isMultiSelect) {
//         valueToStore = Array.isArray(newValue)
//           ? newValue.map((item) => item?.Name_id || item?.id || item?._id || "")
//           : [];
//       } else {
//         // For Project, or any field where object has id/_id/SubTaskId
//         valueToStore = newValue?.Name_id || newValue?.id || newValue?._id || "";
//       }

//       setFormData((prev) => ({
//         ...prev,
//         [name]: valueToStore,
//       }));

//       setFormErrors((prev) => ({
//         ...prev,
//         [name]: "",
//       }));
//     };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const validationErrors = validateForm();
//     if (Object.keys(validationErrors).length > 0) {
//       setFormErrors(validationErrors); // show in UI
//       return;
//     }

//     setFormErrors({}); // clear errors if valid

//     dispatch(CreateAssignTask(formData))
//       .unwrap()
//       .then((res) => {
//         toast.success("Task assigned successfully!");

//         setFormData({
//           CompanyId: "",
//           MemberId: [],
//           DueDate: "",
//           Remark: "",
//           TaskId: "",
//         });
//         dispatch(ShowAssignedTask(parsedData.data._id));
//       })
//       .catch((err) => {
//         toast.error("Failed to assign task: " + err);
//       });
//   };

//   // ========== Dialog State ==========
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedMemberId, setSelectedMemberId] = useState("");
//   const [selectedTaskId, setSelectedTaskId] = useState("");

//   const handleAcceptTask = (mainId) => {
//     setSelectedTaskId(mainId);
//     setOpenDialog(true);
//   };

//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setSelectedMemberId("");
//     setSelectedTaskId("");
//   };

//   const handleMemberChange = (event) => {
//     setSelectedMemberId(event.target.value);
//   };

//   const handleDialogSubmit = () => {
//     if (!selectedMemberId) {
//       toast.error("Please select a member before updating the task.");
//       return;
//     }

//     dispatch(
//       assignTaskChangeMember({
//         taskId: selectedTaskId,
//         newMemberId: selectedMemberId,
//       })
//     );

//     handleDialogClose();
//     toast.success("Task reassigned successfully!");
//   };

//   const columns = [
//     { field: "id", headerName: "Id", flex: 1 },
//     { field: "Member", headerName: "Member", flex: 1 },
//     { field: "Status", headerName: "Status", flex: 1 },
//     { field: "CompanyId", headerName: "Company Name", flex: 1 },
//     { field: "AssignDate", headerName: "Assign Date", flex: 1 },
//     { field: "DueDate", headerName: "Due Date", flex: 1 },
//     {
//       field: "showTask",
//       headerName: "Show Full Task",
//       flex: 1,
//       renderCell: (params) => (
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => navigate(`TaskDetailsDetail/${params.row.MainId}`)}
//         >
//           Show Task
//         </Button>
//       ),
//     },
//     {
//       field: "acceptTask",
//       headerName: "Accept Task",
//       flex: 1,
//       renderCell: (params) =>
//         params.row.Status !== "Pending" ? (
//           <></>
//         ) : (
//           <Button
//             variant="contained"
//             color="secondary"
//             onClick={() => handleAcceptTask(params.row.MainId)}
//           >
//             Assign Change
//           </Button>
//         ),
//     },
//   ];

//   const rows =
//     ShowASsignedTaskData?.data?.map((el, index) => ({
//       id: index + 1,
//       MainId: el._id,
//       Status: el.Status,
//       Member: el?.MemberId?.Name,
//       WhaClientName: el?.WhaClientName,
//       DueDate: formatDate(el.DueDate),
//       AssignDate: formatDate(el.AssignDate),
//     })) || [];

//   return (
//     <div>
//       <div className="Assign_task">
//         <div className="title">
//           <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
//             Assign Task
//           </h3>
//         </div>

//         <div className="Form_bg_color bg-white shadow-md rounded-md mt-4">
//           <form onSubmit={handleSubmit}>
//             <div className="grid grid-cols-12 gap-4 p-3 rounded-2xl">
//               {/* Task ID */}
//               <div className="col-span-12 lg:col-span-6 md:col-span-6">
//                 <h5 className="my-2 font-semibold">Task ID</h5>
//                 <Autocomplete
//                   options={FindAllTask?.data || []}
//                   getOptionLabel={(option) => option?.TastName || ""}
//                   value={
//                     FindAllTask?.data?.find(
//                       (task) => task._id === formData.TaskId
//                     ) || null
//                   }
//                   className="bg-[#F3F8FB]"
//                   onChange={(event, newValue) => {
//                     setFormData((prev) => ({
//                       ...prev,
//                       TaskId: newValue?._id || "",
//                     }));
//                   }}
//                   isOptionEqualToValue={(option, value) =>
//                     option?._id === value?._id || option?._id === value
//                   }
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       placeholder="Enter Task"
//                       variant="outlined"
//                       size="small"
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           "& fieldset": {
//                             borderWidth: "2px",
//                             borderColor: "black",
//                           },
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                       }}
//                       fullWidth
//                       error={!!formErrors.TaskId}
//                       helperText={formErrors.TaskId}
//                     />
//                   )}
//                 />
//               </div>

//               {/* Member ID */}
//               <div className="col-span-12 lg:col-span-6 md:col-span-6">
//                 <h5 className="my-2 font-semibold">Member ID</h5>
//                 <Autocomplete
//                   options={Member || []}
//                   getOptionLabel={(option) => option?.Name_name || ""}
//                   value={
//                     Member.find((m) => m?.Name_id === formData?.MemberId) ||
//                     null
//                   }
//                   className="bg-[#F3F8FB]"
//                   onChange={handleAutocompleteChange("MemberId")} // isMultiSelect = false by default
//                   isOptionEqualToValue={(option, value) =>
//                     option?.Name_id === value?.Name_id ||
//                     option?.Name_id === value
//                   }
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       placeholder="Select Member"
//                       size="small"
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           "& fieldset": {
//                             borderWidth: "2px",
//                             borderColor: "black",
//                           },
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                       }}
//                       fullWidth
//                       variant="outlined"
//                       error={!!formErrors.MemberId}
//                       helperText={formErrors.MemberId}
//                     />
//                   )}
//                 />
//               </div>

//               {/* Company ID */}
//               <div className="col-span-12 lg:col-span-6 md:col-span-6">
//                 <h5 className="my-2 font-semibold">Company ID</h5>
//                 <Autocomplete
//                   options={CustomerData?.data || []}
//                   getOptionLabel={(option) => option?.WhaClientName || ""}
//                   value={
//                     CustomerData?.data?.find(
//                       (c) => c._id === formData?.CompanyId
//                     ) || null
//                   }
//                   className="bg-[#F3F8FB]"
//                   onChange={(event, newValue) => {
//                     setFormData((prev) => ({
//                       ...prev,
//                       CompanyId: newValue ? newValue?._id : "",
//                     }));
//                   }}
//                   isOptionEqualToValue={(option, value) =>
//                     option._id === value?._id
//                   }
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label="Select a Company"
//                       variant="outlined"
//                       size="small"
//                       fullWidth
//                       className="mb-2"
//                       sx={{
//                         "& .MuiOutlinedInput-root": {
//                           "& fieldset": {
//                             borderWidth: "2px",
//                             borderColor: "black",
//                           },
//                           "&:hover fieldset": {
//                             borderColor: "black",
//                           },
//                           "&.Mui-focused fieldset": {
//                             borderColor: "black",
//                           },
//                         },
//                       }}
//                       error={!!formErrors.CompanyId}
//                       helperText={formErrors.CompanyId}
//                     />
//                   )}
//                 />
//               </div>

//               {/* Task End Date */}
//               <div className="col-span-12 lg:col-span-6 md:col-span-6">
//                 <h5 className="my-2 font-semibold">Task End Date</h5>
//                 <input
//                   type="date"
//                   name="DueDate"
//                   value={formData.DueDate}
//                   onChange={handleInputChange}
//                   className={`bg-[#F3F8FB] w-full p-2 border-2 rounded ${
//                     formErrors.DueDate ? "border-red-500" : "border-black"
//                   }`}
//                 />
//                 {formErrors.DueDate && (
//                   <p className="text-red-500 text-[12px] mt-1">
//                     {formErrors.DueDate}
//                   </p>
//                 )}
//               </div>

//               {/* Remark */}
//               <div className="col-span-12">
//                 <h5 className="font-semibold mb-1">Remark</h5>
//                 <textarea
//                   rows="4"
//                   name="Remark"
//                   value={formData.Remark}
//                   onChange={handleInputChange}
//                   className={`bg-[#F3F8FB] w-full p-2 rounded-md border-2 ${
//                     formErrors.Remark ? "border-red-500" : "border-black"
//                   }`}
//                 />
//                 {formErrors.Remark && (
//                   <p className="text-red-500 text-[13px]">
//                     {formErrors.Remark}
//                   </p>
//                 )}
//               </div>

//               {/* Submit */}
//               <div className="submit_Form col-span-12 flex justify-center">
//                 <button type="submit" className="All_button ">
//                   Submit
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>

//         {/* Table */}
//         <div className="my-5">
//           <DynamicTable columns={columns} rows={rows} />
//         </div>
//       </div>
//       {/* ==== Dialog for Task Reassignment ==== */}
//       <Dialog
//         open={openDialog}
//         onClose={handleDialogClose}
//         fullWidth
//         maxWidth="sm"
//       >
//         <DialogTitle>Change Task Assignment</DialogTitle>
//         <DialogContent>
//           <Grid spacing={2}>
//             <Grid item xs={12}>
//               <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
//                 <InputLabel className="w-full" id="member-select-label">
//                   Select Member
//                 </InputLabel>
//                 <Select
//                   labelId="member-select-label"
//                   id="member-select"
//                   value={selectedMemberId}
//                   onChange={handleMemberChange}
//                   label="Select Member"
//                 >
//                   {ActiveMemberData?.data?.map((member) => (
//                     <MenuItem key={member._id} value={member._id}>
//                       {member.Name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleDialogSubmit} color="secondary">
//             Change
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default AssignTask;









import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllProjects,
  fetchAllTypes,
  fetchAllModules,
  fetchCompanyData,
  addComplain,
} from "../../Redux/Slice/RequestServicesSlice";
import {
  findJuniorDevelopers,
  findSupport,
  SeniortoJuniorAssignReq,
} from "../../Redux/Slice/TaskMasterSlice";
import { toast } from "react-toastify";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { UserPlus, X, Clock, CheckCircle2 } from "lucide-react";
import { createPortal } from "react-dom";

const DeveloperAvatar = ({ photo, name, size = "w-8 h-8" }) => {
  const [hasError, setHasError] = useState(false);

  const getInitials = (n) => {
    if (!n) return "EM";
    const parts = n.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return n.slice(0, 2).toUpperCase();
  };

  if (photo && !hasError) {
    return (
      <img
        src={photo}
        alt={name || "Developer"}
        className={`${size} rounded-full object-cover shrink-0 border border-slate-200 shadow-xs`}
        onError={() => setHasError(true)}
      />
    );
  }

  return (
    <div
      className={`${size} rounded-full shrink-0 border border-slate-200 bg-blue-100 text-[#112A47] flex items-center justify-center text-[11px] font-bold tracking-tight uppercase shadow-xs`}
    >
      {getInitials(name)}
    </div>
  );
};

const SearchableDropdown = ({ options, value, onChange, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = options.filter((opt) =>
    (opt.label || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (opt.Role || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedOption = options.find((opt) => opt._id === value);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <label className="block text-xs font-semibold text-slate-700 mb-1 flex items-center justify-between">
        <span>{placeholder}</span>
        <span className="text-red-500 font-bold">*</span>
      </label>
      <div
        className="w-full px-3 py-2 bg-white border border-slate-200 rounded-xl cursor-pointer flex justify-between items-center hover:border-[#112A47] focus:border-[#112A47] focus:ring-2 focus:ring-blue-500/20 transition-all shadow-sm min-h-[42px]"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-2.5 min-w-0 flex-1">
          {selectedOption ? (
            <>
              <DeveloperAvatar photo={selectedOption.ProfilePhoto} name={selectedOption.label} size="w-7 h-7" />
              <span className="text-slate-800 font-semibold text-sm truncate">
                {selectedOption.label}
              </span>
              {selectedOption.isPresent && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full shrink-0">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                  Present
                </span>
              )}
            </>
          ) : (
            <span className="text-slate-400 text-sm">Choose developer...</span>
          )}
        </div>
        <svg
          className={`w-4 h-4 text-slate-400 transition-transform duration-200 shrink-0 ${isOpen ? "rotate-180 text-[#112A47]" : ""}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {isOpen && (
        <div className="absolute z-[100] w-full mt-1 bg-white border border-slate-200 rounded-xl shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-100">
          <div className="p-2 border-b border-slate-100 bg-slate-50/80">
            <input
              type="text"
              className="w-full px-3 py-1.5 text-xs bg-white border border-slate-200 rounded-lg focus:border-[#112A47] focus:ring-2 focus:ring-blue-500/20 outline-none transition-all placeholder:text-slate-400"
              placeholder={`Search ${placeholder}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              autoFocus
            />
          </div>
          <div className="max-h-48 overflow-y-auto p-1 divide-y divide-slate-50">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt) => (
                <div
                  key={opt._id}
                  className={`flex items-center gap-2.5 px-3 py-2 text-sm cursor-pointer transition-colors rounded-lg my-0.5 ${value === opt._id
                    ? "bg-blue-50 text-[#112A47] font-semibold"
                    : "text-slate-700 hover:bg-slate-100/80 hover:text-slate-900"
                    }`}
                  onClick={() => {
                    onChange(opt._id);
                    setIsOpen(false);
                    setSearchTerm("");
                  }}
                >
                  <DeveloperAvatar photo={opt.ProfilePhoto} name={opt.label} size="w-8 h-8" />
                  <div className="flex flex-col min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-1.5">
                      <span className="truncate leading-tight font-medium text-slate-800 text-xs">
                        {opt.label}
                      </span>
                      {opt.isPresent && (
                        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[9px] font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full shrink-0">
                          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                          Present
                        </span>
                      )}
                    </div>
                    {opt.Role && (
                      <span className="text-[10px] text-slate-400 font-normal leading-tight truncate">
                        {opt.Role}
                      </span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="px-4 py-3 text-xs text-slate-400 text-center italic">No developers found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const AssignTask = () => {
  const dispatch = useDispatch();
  const { allProjects, allTypes, allModules, allCompanies } = useSelector(
    (state) => state.RequestService
  );

  const { JuniorDevelopers, DataFindSupport } = useSelector(
    (state) => state.TaskMaster
  );

  const authState = useSelector((state) => state.auth);
  const { LoginData } = authState || {};
  const [iscompony, setiscompony] = useState([]);

  const [showAssignPrompt, setShowAssignPrompt] = useState(false);
  const [newlyCreatedTask, setNewlyCreatedTask] = useState(null);

  // Junior assignment modal states
  const [isJuniorModalOpen, setIsJuniorModalOpen] = useState(false);
  const [selectedJuniorId, setSelectedJuniorId] = useState("");
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [description, setDescription] = useState("");
  const [timeLimitHours, setTimeLimitHours] = useState("");
  const [timeLimitMinutes, setTimeLimitMinutes] = useState("");
  const [minutesError, setMinutesError] = useState("");

  const loggedInUserId = LoginData?.data?._id;

  const juniorOptions = useMemo(() => {
    const map = new Map();
    const seenNames = new Set();

    const addMember = (m, defaultRole) => {
      if (!m || !m._id) return;
      if (loggedInUserId && String(m._id) === String(loggedInUserId)) return;

      const role = (m.Role || defaultRole || "").trim();
      const roleLower = role.toLowerCase();
      if (roleLower.includes("owner")) return;

      const isDelphiSenior =
        roleLower.includes("delphi") &&
        (roleLower.includes("senior") || roleLower.includes("lead"));
      const isSupport = roleLower.includes("support");

      if (!isDelphiSenior && !isSupport) return;

      const name = (m.Name || "").trim();
      if (!name) return;
      const nameKey = name.toLowerCase();
      const idKey = String(m._id);

      if (!map.has(idKey) && !seenNames.has(nameKey)) {
        seenNames.add(nameKey);
        map.set(idKey, {
          label: name,
          _id: m._id,
          ProfilePhoto: m.ProfilePhoto || null,
          Role: role || defaultRole,
          isPresent: Boolean(m.isPresent),
          punchInTime: m.punchInTime || null,
        });
      }
    };

    if (Array.isArray(JuniorDevelopers?.data)) {
      JuniorDevelopers.data.forEach((d) => addMember(d, "Developer"));
    }
    if (Array.isArray(DataFindSupport?.data)) {
      DataFindSupport.data.forEach((s) => addMember(s, "Customer Support"));
    }

    return Array.from(map.values()).sort((a, b) =>
      (a.label || "").localeCompare(b.label || "")
    );
  }, [JuniorDevelopers?.data, DataFindSupport?.data, loggedInUserId]);

  const [formData, setFormData] = useState({
    Type: null,
    Project: "",
    Requirement_Type: "",
    InPutId: LoginData?.data?._id,
    Module: null,
    CompanyName: "",
    PresentStatus: "",
    Requirement: "",
    photos: Array(5).fill({ base64: "", fileObject: null, previewUrl: "" }),
    Solution: "",
    Benefit: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchCompanyData());
    dispatch(findJuniorDevelopers());
    dispatch(findSupport());
  }, [dispatch]);

  useEffect(() => {
    if (formData.Project !== "") {
      dispatch(fetchAllTypes(formData?.Project));
    }
    if (formData.Type !== "") {
      dispatch(fetchAllModules(formData.Type));
    }
  }, [formData.Project, formData.Type, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    allCompanies?.data?.find((el) => {
      if (el._id === value) {
        setiscompony(el.Project);
        return true;
      }
    });
  };

  const handleFileChange = (index, file) => {
    if (!file) return;

    // Create object URL for instant preview
    const previewUrl = URL.createObjectURL(file);

    // Also read as base64 for submission
    const reader = new FileReader();
    reader.onloadend = () => {
      const newPhotos = [...formData.photos];
      newPhotos[index] = {
        base64: reader.result,
        fileObject: file,
        previewUrl: previewUrl,
        fileName: file.name,
        fileType: file.type,
        id: `file-${Date.now()}-${index}`
      };
      setFormData((prev) => ({ ...prev, photos: newPhotos }));
    };
    reader.readAsDataURL(file);
  };

  const handleRemovePhoto = (index) => {
    // Revoke the object URL to prevent memory leaks
    if (formData.photos[index].previewUrl) {
      URL.revokeObjectURL(formData.photos[index].previewUrl);
    }

    const newPhotos = [...formData.photos];
    newPhotos[index] = { base64: "", fileObject: null, previewUrl: "", fileName: "", fileType: "", id: "" };

    // Shift all files up
    for (let i = index; i < newPhotos.length - 1; i++) {
      newPhotos[i] = newPhotos[i + 1];
    }
    newPhotos[newPhotos.length - 1] = { base64: "", fileObject: null, previewUrl: "", fileName: "", fileType: "", id: "" };

    setFormData((prev) => ({ ...prev, photos: newPhotos }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = [
      "Project",
      "Requirement_Type",
      "CompanyName",
      "PresentStatus",
      "Requirement",
    ];

    let allFieldsFilled = true;
    let missingFields = [];

    requiredFields.forEach((field) => {
      if (
        !formData[field] ||
        (typeof formData[field] === "string" && formData[field].trim() === "")
      ) {
        allFieldsFilled = false;
        missingFields.push(field);
      }
    });

    if (allFieldsFilled) {
      setShowModal(true);
      setValidated(false);
    } else {
      setValidated(true);
      toast.error(
        `Please fill all required fields: ${missingFields.join(", ")}`,
        {
          position: "top-right",
          autoClose: 5000,
          zIndex: 1000,
        }
      );
    }
  };

  const handleConfirmSubmit = () => {
    // Prepare data for submission
    const submissionData = {
      ...formData,
      photos: formData.photos
        .filter(photo => photo.base64)
        .map(photo => photo.base64)
    };

    const payload = { values: submissionData };

    dispatch(addComplain(payload)).then((res) => {
      const status = typeof res.payload === "string" ? res.payload : res.payload?.status;
      if (status === "Dev Conplain added") {
        toast.success("Complaint submitted successfully!");

        // Clean up object URLs
        formData.photos.forEach(photo => {
          if (photo.previewUrl) {
            URL.revokeObjectURL(photo.previewUrl);
          }
        });

        setValidated(false);
        const taskData = typeof res.payload === "string" ? null : res.payload?.data;
        if (taskData) {
          setNewlyCreatedTask(taskData);
          setShowAssignPrompt(true);
        } else {
          window.location.reload();
        }
      } else {
        toast.error("Failed to submit request. Please try again.");
      }
    });
    setShowModal(false);
  };

  // Clean up object URLs when component unmounts
  useEffect(() => {
    return () => {
      formData.photos.forEach(photo => {
        if (photo.previewUrl) {
          URL.revokeObjectURL(photo.previewUrl);
        }
      });
    };
  }, []);

  const isImageFile = (fileType) => {
    return fileType && fileType.startsWith('image/');
  };

  const isPDFFile = (fileType) => {
    return fileType === 'application/pdf';
  };

  const getFileIcon = (type) => {
    if (isImageFile(type)) return "bi bi-file-earmark-image";
    if (isPDFFile(type)) return "bi bi-file-earmark-pdf";
    if (type.includes("word")) return "bi bi-file-earmark-word";
    if (type.includes("excel") || type.includes("spreadsheet")) return "bi bi-file-earmark-excel";
    if (type.includes("text")) return "bi bi-file-earmark-text";
    return "bi bi-file-earmark";
  };

  const getFileColor = (type) => {
    if (isImageFile(type)) return "text-green-600";
    if (isPDFFile(type)) return "text-red-600";
    if (type.includes("word")) return "text-blue-600";
    if (type.includes("excel") || type.includes("spreadsheet")) return "text-green-600";
    return "text-gray-600";
  };

  const getFileBgColor = (type) => {
    if (isImageFile(type)) return "bg-green-100 border-green-300";
    if (isPDFFile(type)) return "bg-red-100 border-red-300";
    if (type.includes("word")) return "bg-blue-100 border-blue-300";
    if (type.includes("excel") || type.includes("spreadsheet")) return "bg-green-100 border-green-300";
    return "bg-gray-100 border-gray-300";
  };

  const openPhotoModal = (photo) => setSelectedPhoto(photo);
  const closePhotoModal = () => setSelectedPhoto(null);

  return (
    <div className="">
      <div className="title">
        <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
          Request Form
        </h3>
      </div>

      <div className="Form_bg_color bg-white p-6 shadow-sm rounded-xl mt-4">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Grid Layout */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Type */}
            <div>
              <h5 className="mb-[5px] block font-semibold">
                Type <span className="text-red-500">*</span>
              </h5>
              <select
                name="Requirement_Type"
                value={formData.Requirement_Type}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
                required
              >
                <option value="">Select Type</option>
                <option value="New Requirment">New Requirement</option>
                <option value="Error">Error</option>
                <option value="Modify">Modify</option>
                <option value="Training">Training</option>
              </select>
            </div>

            {/* Company */}
            <div>
              <h5 className="mb-[5px] block font-semibold">
                Company Name <span className="text-red-500">*</span>
              </h5>
              <select
                name="CompanyName"
                value={formData.CompanyName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Company</option>
                {allCompanies?.data
                  ?.filter((el) => el._id === "679c60b7c165ac4d75ecfd21")
                  ?.map((el) => (
                    <option key={el._id} value={el._id}>
                      {el.WhaClientName}
                    </option>
                  ))}
              </select>
            </div>

            {/* Project */}
            <div>
              <h5 className="mb-[5px] block font-semibold">
                Project <span className="text-red-500">*</span>
              </h5>
              <select
                name="Project"
                value={formData.Project}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Project</option>
                {iscompony?.map((proj) => (
                  <option key={proj._id} value={proj._id}>
                    {proj.project_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Requirement Type */}
            <div>
              <h5 className="mb-[5px] block font-semibold">Requirement Type</h5>
              <select
                name="Type"
                value={formData.Type}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Requirement Type</option>
                {allTypes?.data?.map((el) => (
                  <option key={el._id} value={el._id}>
                    {el.Type_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Module */}
            <div>
              <h5 className="mb-[5px] block font-semibold">Module</h5>
              <select
                name="Module"
                value={formData.Module}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              >
                <option value="">Select Module</option>
                {allModules?.data?.map((el) => (
                  <option key={el._id} value={el._id}>
                    {el.module_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Textareas */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h5 className="mb-[5px] block font-semibold">
                Present Status <span className="text-red-500">*</span>
              </h5>
              <textarea
                name="PresentStatus"
                value={formData.PresentStatus}
                onChange={handleChange}
                rows={3}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              />
            </div>
            <div>
              <h5 className="mb-[5px] block font-semibold">
                Your Requirement <span className="text-red-500">*</span>
              </h5>
              <textarea
                name="Requirement"
                value={formData.Requirement}
                onChange={handleChange}
                rows={3}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              />
            </div>
            <div>
              <h5 className="mb-[5px] block font-semibold">
                Solution <span className="text-red-500">*</span>
              </h5>
              <textarea
                name="Solution"
                value={formData.Solution}
                onChange={handleChange}
                rows={3}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              />
            </div>
            <div>
              <h5 className="mb-[5px] block font-semibold">
                Benefit From This <span className="text-red-500">*</span>
              </h5>
              <textarea
                name="Benefit"
                value={formData.Benefit}
                onChange={handleChange}
                rows={3}
                className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
              />
            </div>
          </div>

          {/* Photos */}
          <div>
            <h5 className="mb-[5px] block font-semibold">Attachments (Optional)</h5>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {formData.photos.map((photo, index) => {
                const isCurrentFilled = photo.base64 !== "";
                const isPreviousFilled = index === 0 || formData.photos[index - 1].base64 !== "";

                if (!isPreviousFilled && !isCurrentFilled) {
                  return null;
                }

                return (
                  <div key={photo.id || index} className="space-y-2">
                    {/* File Input */}
                    <input
                      type="file"
                      onChange={(e) => handleFileChange(index, e.target.files[0])}
                      className="bg-[#F3F8FB] w-full p-[2px] border-2 border-black rounded"
                      accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                    />

                    {/* Preview Section */}
                    {isCurrentFilled && (
                      <div
                        className={`cursor-pointer ${getFileBgColor(photo.fileType)} rounded-lg p-3 border transition-all duration-200 hover:shadow-md hover:scale-[1.02]`}
                        onClick={() => openPhotoModal(photo)}
                      >
                        <div className="flex flex-col items-center text-center">
                          {isImageFile(photo.fileType) ? (
                            <div className="mb-2 h-24 w-full overflow-hidden rounded-md">
                              <img
                                src={photo.previewUrl}
                                alt={`Preview ${index + 1}`}
                                className="w-full h-full object-cover"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  // Fallback to base64 if object URL fails
                                  e.target.src = photo.base64;
                                }}
                              />
                            </div>
                          ) : (
                            <i className={`${getFileIcon(photo.fileType)} ${getFileColor(photo.fileType)} mb-2`} style={{ fontSize: 40 }}></i>
                          )}

                          <p className="text-xs font-medium truncate w-full mb-1">
                            {photo.fileName || `Attachment ${index + 1}`}
                          </p>
                          <span className="text-xs text-gray-500 capitalize">
                            {isImageFile(photo.fileType) ? "Image" :
                              isPDFFile(photo.fileType) ? "PDF" :
                                photo.fileType.split('/')[1] || "File"}
                          </span>

                          {/* Remove Button */}
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemovePhoto(index);
                            }}
                            className="mt-2 text-xs bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <button
            type="submit"
            className="bg-[#122A47] text-white py-2 px-2 md:px-4 rounded hover:bg-[#0c2545]"
          >
            Submit
          </button>
        </form>
      </div>

      {/* Preview Modal */}
      {selectedPhoto && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
          onClick={closePhotoModal}
        >
          <div
            className="relative max-w-[95vw] max-h-[95vh] overflow-auto bg-white rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closePhotoModal}
              className="absolute top-3 right-3 text-gray-700 hover:text-red-600 text-3xl z-10 bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-md"
            >
              &times;
            </button>

            <div className="p-4">
              {(() => {
                const fileType = selectedPhoto.fileType;
                const isImage = isImageFile(fileType);
                const isPDF = isPDFFile(fileType);

                return (
                  <>
                    {/* IMAGE PREVIEW */}
                    {isImage && (
                      <div className="p-2">
                        <TransformWrapper
                          initialScale={1}
                          minScale={0.5}
                          maxScale={10}
                          centerOnInit={true}
                        >
                          <TransformComponent>
                            <img
                              src={selectedPhoto.previewUrl}
                              alt={selectedPhoto.fileName}
                              className="max-h-[70vh] max-w-full mx-auto rounded-lg"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = selectedPhoto.base64;
                              }}
                            />
                          </TransformComponent>
                        </TransformWrapper>
                      </div>
                    )}

                    {/* PDF PREVIEW */}
                    {isPDF && (
                      <div className="p-2">
                        <iframe
                          src={selectedPhoto.base64}
                          className="w-full h-[80vh] rounded-lg border-0"
                          title="PDF Preview"
                        />
                      </div>
                    )}

                    {/* OTHER FILE TYPES */}
                    {!isImage && !isPDF && (
                      <div className="p-10 text-center">
                        <i className={`${getFileIcon(fileType)} ${getFileColor(fileType)}`} style={{ fontSize: 80 }}></i>
                        <p className="mt-4 text-lg font-semibold">
                          {selectedPhoto.fileName || "Attachment"}
                        </p>
                        <p className="text-gray-600 capitalize">File Type: {fileType.split('/')[1] || "Document"}</p>
                        <p className="text-sm text-gray-500 mt-2">Preview not available for this file type</p>
                        <a
                          href={selectedPhoto.base64}
                          download={selectedPhoto.fileName || `attachment_${Date.now()}`}
                          className="mt-6 inline-block bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
                        >
                          Download File
                        </a>
                      </div>
                    )}

                    <div className="text-center mt-4 p-4 border-t">
                      <p className="text-lg font-semibold text-gray-800">
                        {selectedPhoto.fileName || "Attachment"}
                      </p>
                      <p className="text-sm text-gray-600">
                        Type: <span className="capitalize">
                          {isImage ? "Image" :
                            isPDF ? "PDF" :
                              fileType.split('/')[1] || "File"}
                        </span>
                      </p>
                    </div>
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}

      {/* Confirm Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg p-6 w-80">
            <h3 className="text-lg font-semibold mb-4">Confirm Submission</h3>
            <p>Are you sure you want to submit this form?</p>

            {/* Show attachments in modal */}
            {formData.photos.filter(photo => photo.base64).length > 0 && (
              <div className="mt-4">
                <h4 className="text-sm font-semibold mb-2">Attachments:</h4>
                <div className="flex flex-wrap gap-2">
                  {formData.photos.filter(photo => photo.base64).map((photo, index) => (
                    <div key={index} className="text-xs bg-gray-100 px-2 py-1 rounded flex items-center">
                      {isImageFile(photo.fileType) ? (
                        <>
                          <i className="bi bi-file-earmark-image text-blue-500 mr-1"></i>
                          <span className="text-blue-500">Image {index + 1}</span>
                        </>
                      ) : isPDFFile(photo.fileType) ? (
                        <>
                          <i className="bi bi-file-earmark-pdf text-red-500 mr-1"></i>
                          <span className="text-red-500">PDF {index + 1}</span>
                        </>
                      ) : (
                        <>
                          <i className="bi bi-file-earmark text-gray-500 mr-1"></i>
                          <span className="text-gray-500">File {index + 1}</span>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-1 rounded bg-gray-300 hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmSubmit}
                className="px-4 py-1 rounded bg-blue-600 text-white hover:bg-blue-700"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm Assign Prompt */}
      {showAssignPrompt && typeof document !== "undefined" && createPortal(
        <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-[99999] p-4 animate-in fade-in duration-200 overflow-y-auto">
          <div className="bg-white rounded-2xl p-6 w-[90%] max-w-sm shadow-2xl border border-slate-100">
            <h3 className="text-lg font-bold mb-2 text-slate-800">Assign Task</h3>
            <p className="text-slate-600 text-sm mb-6">Do you want to assign this task to an employee now?</p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowAssignPrompt(false);
                  window.location.reload();
                }}
                className="px-4 py-2 rounded-xl border border-slate-200 hover:bg-slate-100 text-slate-700 font-medium transition-colors text-sm"
              >
                No
              </button>
              <button
                onClick={() => {
                  setShowAssignPrompt(false);
                  setSelectedTaskId({ ...newlyCreatedTask, MainId: newlyCreatedTask?._id });
                  setIsJuniorModalOpen(true);
                }}
                className="px-4 py-2 rounded-xl bg-[#112A47] text-white hover:bg-[#0c2545] font-semibold transition-colors shadow-md text-sm"
              >
                Yes
              </button>
            </div>
          </div>
        </div>,
        document.body)}

      {/* Modal for Junior Developer */}
      {isJuniorModalOpen && typeof document !== "undefined" && createPortal(
        <div
          className="fixed inset-0 z-[99999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-opacity animate-in fade-in duration-200 overflow-y-auto"
          onClick={() => {
            setIsJuniorModalOpen(false);
            setSelectedJuniorId("");
            setSelectedTaskId(null);
            setDescription("");
            setTimeLimitHours("");
            setTimeLimitMinutes("");
            setMinutesError("");
            window.location.reload();
          }}
        >
          <div
            className="relative w-full max-w-lg bg-white rounded-2xl shadow-2xl border border-slate-100 flex flex-col overflow-visible animate-in fade-in zoom-in-95 duration-200 my-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="px-6 py-3.5 bg-gradient-to-r from-[#112A47] to-[#1c3a60] text-white flex items-center justify-between shadow-sm rounded-t-2xl">
              <div className="flex items-center gap-2.5">
                <div className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center text-white border border-white/15 shadow-inner">
                  <UserPlus size={18} />
                </div>
                <div>
                  <h2 className="text-base font-bold tracking-wide text-white leading-tight">
                    Select Junior Developer
                  </h2>
                  <p className="text-[11px] text-blue-200/90 font-normal">
                    Assign task and set allocated time limit
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => {
                  setIsJuniorModalOpen(false);
                  setSelectedJuniorId("");
                  setSelectedTaskId(null);
                  setDescription("");
                  setTimeLimitHours("");
                  setTimeLimitMinutes("");
                  setMinutesError("");
                  window.location.reload();
                }}
                className="text-white/70 hover:text-white hover:bg-white/10 p-1.5 rounded-lg transition-colors focus:outline-none"
                title="Close"
              >
                <X size={18} />
              </button>
            </div>

            {/* Body */}
            <div className="p-5 space-y-3">
              {/* Task Context Card */}
              {selectedTaskId && (selectedTaskId.tokan || selectedTaskId.CallNo || selectedTaskId.Requirement) && (
                <div className="p-2.5 bg-blue-50/60 border border-blue-100 rounded-xl space-y-0.5 text-xs">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-bold text-[#112A47] text-xs">
                      Call #{selectedTaskId.tokan || selectedTaskId.CallNo || "—"}
                    </span>
                    <span className="font-medium text-slate-700 bg-white px-2 py-0.5 rounded-md border border-blue-100 text-[11px] truncate max-w-[200px]">
                      {selectedTaskId.CompanyName || "Task Assignment"}
                    </span>
                  </div>
                  {selectedTaskId.Requirement && (
                    <p className="text-slate-600 text-[11px] line-clamp-2 pt-0.5 border-t border-blue-100/70">
                      <span className="font-semibold text-slate-700">Req: </span>
                      {selectedTaskId.Requirement}
                    </p>
                  )}
                </div>
              )}

              {/* Developer Dropdown */}
              <SearchableDropdown
                options={juniorOptions}
                value={selectedJuniorId}
                onChange={(id) => setSelectedJuniorId(id)}
                placeholder="Junior Developer"
                renderItem={(option) => (
                  <div className="flex items-center gap-2">
                    <DeveloperAvatar name={option.label} />
                    <span>{option.label}</span>
                  </div>
                )}
              />

              {/* Description */}
              <div className="flex flex-col gap-1">
                <label className="text-xs font-semibold text-slate-700 flex items-center justify-between">
                  <span>Instructions / Description</span>
                  <span className="text-slate-400 font-normal text-[11px]">(Optional)</span>
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter instructions or notes for junior developer..."
                  className="w-full px-3 py-2 text-xs bg-white border border-slate-200 rounded-xl focus:border-[#112A47] focus:ring-2 focus:ring-blue-500/20 outline-none transition-all resize-none placeholder:text-slate-400"
                  rows={2}
                ></textarea>
              </div>

              {/* Estimated Time Limit */}
              <div className="p-2.5 bg-slate-50 border border-slate-200/80 rounded-xl space-y-1.5">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                    <Clock size={14} className="text-[#112A47]" />
                    <span>Estimated Time Limit</span>
                  </div>
                  <span className="text-slate-400 text-[11px] font-normal">(HH : MM)</span>
                </div>

                <div className="grid grid-cols-2 gap-2.5">
                  <div>
                    <label className="text-[10px] font-medium text-slate-500 mb-0.5 block">Hours</label>
                    <div className="relative">
                      <input
                        type="number"
                        value={timeLimitHours}
                        onChange={(e) => setTimeLimitHours(e.target.value)}
                        placeholder="e.g. 02"
                        className="w-full px-2.5 py-1.5 text-xs bg-white border border-slate-200 rounded-lg focus:border-[#112A47] focus:ring-2 focus:ring-blue-500/20 outline-none transition-all placeholder:text-slate-300"
                        min="0"
                      />
                      <span className="absolute right-2.5 top-1.5 text-[11px] text-slate-400 pointer-events-none">hrs</span>
                    </div>
                  </div>

                  <div>
                    <label className="text-[10px] font-medium text-slate-500 mb-0.5 block">Minutes</label>
                    <div className="relative">
                      <input
                        type="number"
                        value={timeLimitMinutes}
                        onChange={(e) => {
                          let val = e.target.value;
                          if (val.length > 2) val = val.slice(0, 2);
                          if (parseInt(val || "0", 10) > 60) {
                            setMinutesError("Minutes cannot be more than 60");
                          } else {
                            setMinutesError("");
                          }
                          setTimeLimitMinutes(val);
                        }}
                        placeholder="e.g. 30"
                        className={`w-full px-2.5 py-1.5 text-xs bg-white border rounded-lg focus:border-[#112A47] focus:ring-2 focus:ring-blue-500/20 outline-none transition-all placeholder:text-slate-300 ${minutesError ? "border-red-500 ring-1 ring-red-200" : "border-slate-200"
                          }`}
                        min="0"
                        max="59"
                      />
                      <span className="absolute right-2.5 top-1.5 text-[11px] text-slate-400 pointer-events-none">min</span>
                    </div>
                    {minutesError && (
                      <p className="text-red-500 text-[10px] mt-0.5 font-medium">{minutesError}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 py-3 border-t border-slate-100 bg-slate-50/80 flex items-center justify-end gap-2.5 rounded-b-2xl">
              <button
                type="button"
                className="px-4 py-1.5 text-xs font-semibold text-slate-600 hover:text-slate-800 hover:bg-slate-200/60 rounded-xl transition-all"
                onClick={() => {
                  setIsJuniorModalOpen(false);
                  setSelectedJuniorId("");
                  setSelectedTaskId(null);
                  setDescription("");
                  setTimeLimitHours("");
                  setTimeLimitMinutes("");
                  setMinutesError("");
                  window.location.reload();
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                className="px-5 py-1.5 text-xs font-semibold text-white bg-[#112A47] hover:bg-[#0c2545] rounded-xl shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2"
                disabled={!selectedJuniorId}
                onClick={() => {
                  if (parseInt(timeLimitMinutes || "0", 10) >= 60) {
                    toast.error("Please enter valid minutes (less than 60).", { autoClose: 2000 });
                    return;
                  }

                  const seniorId = LoginData?.data?._id;

                  toast.info("Assigning task to junior...", { autoClose: 1500 });

                  dispatch(
                    SeniortoJuniorAssignReq({
                      complainBoxId: selectedTaskId.MainId,
                      SuportTeamId: selectedJuniorId,
                      DescripTione: description,
                      SeniorDevloperID: seniorId,
                      TimeLimit:
                        !timeLimitHours && !timeLimitMinutes
                          ? null
                          : `${(timeLimitHours || "00").toString().padStart(2, "0")}:${(timeLimitMinutes || "00").toString().padStart(2, "0")}`,
                    })
                  )
                    .then((res) => {
                      if (res.meta.requestStatus === "fulfilled") {
                        toast.success("Task assigned to junior successfully!");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      } else {
                        toast.error("Failed to assign task to junior.");
                      }
                    })
                    .catch((err) => {
                      toast.error("An error occurred while assigning task.");
                    });

                  setIsJuniorModalOpen(false);
                  setSelectedJuniorId("");
                  setSelectedTaskId(null);
                  setDescription("");
                  setTimeLimitHours("");
                  setTimeLimitMinutes("");
                  setMinutesError("");
                }}
              >
                <CheckCircle2 size={16} />
                <span>Assign Task</span>
              </button>
            </div>
          </div>
        </div>,
        document.body)}
    </div>
  );
};

export default AssignTask;